import { render } from "./updateHistory.vue?vue&type=template&id=1fb90e6f&scoped=true"
import script from "./updateHistory.vue?vue&type=script&lang=js"
export * from "./updateHistory.vue?vue&type=script&lang=js"

import "./updateHistory.vue?vue&type=style&index=0&id=1fb90e6f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb90e6f"]])

export default __exports__